<template>
  <div>
    <div class="box pt-60 pl-80 pr-80 pb-24">
      <div class="container-1752">
        <div class="page-tab pt-26 df aic">
          <span class="ip1 cup" @click="handleStationed('/stationed/index')">{{ $t('驻站专家') }}</span>
          <span class="active ml-22">MVP</span>
        </div>
        <div class="card1">
          <div class="t1">MOST VALUABLE</div>
          <div class="t2">
            <span class="s1">OceanClub</span>
            <span class="s2">{{ $t('最具价值专家') }}</span>
          </div>
          <div class="desc break-word four-text">
            {{
              $t('MVP 是社区授予的最高荣誉,是年度评选的OceanClub社区最佳价值专家。')
            }}
          </div>
        </div>

        <!-- 新增专家列表 -->
        <div class="mvp-box mt-40">

          <div class="mvp-search">
            <div class="df aic">
              <span class="t1 lh-36 fs-20 c-7"> {{ $t('年份') }}</span>
              <div class="df fs-20 c-19">
                <template v-for="(item, index) in yearData">
                  <span class="list mr-30" @click="() => (FormData['curr_year'] = item.value)"
                    :class="{ active: FormData['curr_year'] == item.value }">{{ item.label }}</span>
                </template>
              </div>
            </div>

            <!--            <div class="df aic mt-12">-->
            <!--              <span class="t1 lh-36 fs-20 c-7">区域</span>-->
            <!--              <div class="df fs-20 c-19">-->
            <!--                <span class="list mr-30">全部</span>-->
            <!--                <span class="active list mr-30">北美</span>-->
            <!--                <span class="list mr-30">南美</span>-->
            <!--                <span class="list mr-30">非洲</span>-->
            <!--                <span class="list mr-30">亚洲</span>-->
            <!--                <span class="list mr-30">欧洲</span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>


          <div class="mvp-contentlist df fww mt-40">
            <template v-for="(item, index) in listdata">
              <div class="list cup" @click="handleLink(item.user_id)" @mouseenter="item.showButton = true"
                @mouseleave="item.showButton = false">
                <div class="top-img">
                  <img :src="item.tesa_personal_photo_mvp_arr" alt="">
                </div>
                <div class="text-box pl-24 pr-24 pt-16">
                  <div class="name pb-16 lh-28 o-h">

                    <div class="df aic o-h">
                      <span class="fs-24 one-text fw-b c-12 pb-2" style="min-width: 100px;" :title="item.user_name">{{
                        item.user_name }}</span>
                      <div class="one-text ml-8 dj d1">
                        <template v-for="(item, index) in item.user_logo_arr">
                          <img :src="require('@/assets/images/grade/sign-' + item)" class="mr-1" alt=""
                            v-if="!currLanguage">
                          <img :src="require('@/assets/images/grade_en/sign-' + item)" alt="" v-else>
                        </template>
                        <template v-if="item.user_medal_arr">
                          <img :src="require('@/assets/images/grade/level-' + item.user_medal + '.png')"
                            v-if="!currLanguage" alt="">
                          <img :src="require('@/assets/images/grade_en/level-' + item.user_medal + '.png')" v-else
                            alt="">
                        </template>
                      </div>
                    </div>




                    <div class="mt-8 fs-16 lh-22 df aic">
                      <div class="c-12 one-text" :title="(item.tesa_company || '') + '/' + (item.user_job_name || '')">
                        {{ item.tesa_company }}/{{ item.user_job_name ?? '' }}
                      </div>
                    </div>
                    <div class="country-box mt-4" v-if="item.country_name">
                      <span style="background: #F3F3F3;padding: 3px 8px;border-radius: 4px;color: #333;font-size: 12px;">{{ item.country_name }}</span>
                    </div>
                    <div class="tow-text h-44 mt-8 c-7 fs-14 lh-22 df aic" :title="item.tesa_core_contribute">
                      {{ item.tesa_core_contribute }}
                    </div>

                  </div>

                  <div class="art-box">
                    <template v-for="(article, index1) in item.article_list">
                      <div class="li one-text cup" @click="handleArticleLink(article)" :title="article.title">
                        <span>【{{ article.compose_type === 10 ? $t('文章') : $t('文章') }}】</span>
                        {{ article.title }}
                      </div>
                    </template>

                  </div>


                </div>

                <el-button type="primary" size="mini" class="follow-btn"
                  :class="{ 'follow-btnend': item.have_be_follow == 10 }"
                  @click.stop="(event) => userfollowAdd(event, item)">
                  {{ item.have_be_follow == 10 ? $t('已关注') : `+ ${$t('关注')}` }}</el-button>

              </div>
            </template>
          </div>

          <!-- pageing -->
          <div class="pageing-box mt-32 df aic jcc">
            <el-pagination layout="prev, next" :total="pagination.total" :page-size="pagination.page_size"
              @current-change="handleCurrentChange">
            </el-pagination>
            <!-- <span class="iconfont icon-youbian1-copy"></span>
            <span class="iconfont icon-youbian1"></span> -->
          </div>



        </div>



        <!-- 5.19MVP注释 start-->
        <!-- <div class="topcontent-page mt-26 pl-60 pr-60">
        <div class="container-1752">
          <div class="t2">{{ $t('MVP') }}</div>
        </div>
        
        <div class="person-list">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in numbers" :key="index">
              <div class="df fww leng10box">
                <div v-for="(items, indexs) in numbers[index]" class="leng10list" style="width: 20%">
                  <div class="list-box" :class="{ 'list-boxend': items.have_be_follow == 10 }"
                    @click="handleLink(items.user_id)">
                    <div class="list">
                      <div class="img-box">
                        <img :src="items.tesa_personal_photo_arr" alt="">
                      </div>
                      <div class="text-box">
                        <div class="name one-text">{{ items.user_name }}</div>
                        <div class="company tow-text">
                          <template v-if="items.tesa_company_show == 10">
                            {{ items.tesa_company }}
                          </template>
{{ items.user_job_name }}
</div>

<div class="desc tow-text" v-if="items.user_excel_arr.length">

  <span v-for="(items1, index1) in items.user_excel_arr">

    {{ items1.label }}<span v-if="index1 < items.user_excel_arr.length - 1">、</span>
  </span>
</div>
</div>
</div>
<el-button type="primary" class="follow-btn" :class="{ 'follow-btnend': items.have_be_follow == 10 }"
  @click.stop="(event) => userfollowAdd(event, items)">
  {{ items.have_be_follow == 10 ? $t('已关注') : `+ ${$t('关注')}` }}</el-button>
</div>
</div>
</div>
</swiper-slide>
</swiper>
<div class="swiper-btn df aic jcc">
  <div class="swiper-button-prev" id="topic_prev"></div>
  <div class="swiper-button-next" id="topic_next"></div>
</div>
</div>

</div>-->
        <!-- 5.19MVP注释 end-->


        <div class="cars2">
          <div class="t1">- {{ $t('欢迎成为最具价值专家') }} -</div>
          <div class="t2">{{ $t('MVP权益') }}</div>

          <div class="card2-box mt-30">
            <div class="li-box df jcsb">
              <div class="li f1 ta-c over-h">
                <div class="img-box">
                  <div class="img-li">
                    <img :src="require('../../assets/images/img/s1.png')" alt="">
                  </div>
                  <p class="ta-c one-text break-word" :title="$t('专属荣誉')">{{ $t('专属荣誉') }} </p>
                  <div class="desc three-text">
                    <p :title="$t('MVP奖杯及奖状')">{{ $t('MVP奖杯及奖状') }}</p>
                  </div>
                </div>
              </div>
              <div class="li f1 ta-c over-h">
                <div class="img-box">
                  <div class="img-li">
                    <img :src="require('../../assets/images/img/s2.png')" alt="">
                  </div>
                  <p class="ta-c one-text break-word" :title="$t('颁奖典礼')">{{ $t('颁奖典礼') }} </p>
                  <div class="desc break-word three-text">
                    <p :title="$t('OceanClub年度全球最大盛会')">{{ $t('OceanClub年度全球最大盛会') }}</p>
                  </div>
                </div>
              </div>
              <div class="li f1 ta-c over-h">
                <div class="img-box">
                  <div class="img-li">
                    <img :src="require('../../assets/images/img/s3.png')" alt="">
                  </div>

                  <p class="ta-c one-text break-word" :title="$t('媒体采访')">{{ $t('媒体采访') }}</p>
                  <div class="desc break-word three-text">
                    <p :title="$t('个人专访、文章报导')">{{ $t('个人专访、文章报导') }}</p>
                  </div>
                </div>
              </div>
              <div class="li f1 ta-c over-h">
                <div class="img-box">
                  <div class="img-li">
                    <img :src="require('../../assets/images/img/s5.png')" alt="">
                  </div>

                  <p class="ta-c one-text break-word" :title="$t('社区展播')">{{ $t('社区展播') }} </p>
                  <div class="desc break-word three-text">
                    <p :title="$t('MVP展示页，内容包含电子徽章、简介、照片、文章等')">{{ $t('MVP展示页，内容包含电子徽章、简介、照片、文章等') }}</p>
                  </div>
                </div>
              </div>
              <div class="li f1 ta-c over-h">
                <div class="img-box">
                  <div class="img-li">
                    <img :src="require('../../assets/images/img/s4.png')" alt="">
                  </div>

                  <p class="ta-c one-text break-word" :title="$t('参观知名企业')">{{ $t('参观知名企业') }}</p>
                  <div class="desc break-word three-text">
                    <p :title="$t('同时与高层面对面交流')">{{ $t('同时与高层面对面交流') }}</p>
                  </div>
                </div>
              </div>
              <!-- <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s6.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('高端技术圈层活动') }}</p>
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card3 pl-80 pr-80">
      <div class="container-1752">
        <div class="t1s">{{ $t('如何成为MVP?') }}</div>
        <div class="card3-box pt-56 df jcsb">

          <div class="li">
            <img src="@/assets/images/img/mvp-img1.png" alt="">
            <p class="t1" :title="$t('技术影响力')">{{ $t('技术影响力') }}</p>
            <div class="t2" style="max-width: 350px;">
              <p class="three-text" :title="$t('获得IT领域高级认证证书；')">{{ $t('获得IT领域高级认证证书；') }}</p>
            </div>
          </div>
          <div class="li">
            <img src="@/assets/images/img/mvp-img4.png" alt="">
            <p class="t1" :title="$t('社区影响力')">{{ $t('社区影响力') }}</p>
            <div class="t2" style="max-width: 350px;">
              <p class="three-text" :title="$t('在社区内活跃度高；')">{{ $t('在社区内活跃度高；') }}</p>
            </div>
          </div>
          <div class="li">
            <img src="@/assets/images/img/mvp-img5.png" alt="">
            <p class="t1" :title="$t('项目实践')">{{ $t('项目实践') }}</p>
            <div class="t2" style="max-width: 350px;">
              <p class="three-text" :title="$t('有引领产业趋势，且能对外分享/传播的数据存储最佳实践')">{{ $t('有引领产业趋势，且能对外分享/传播的数据存储最佳实践') }}</p>
            </div>
          </div>
          <div class="li">
            <img src="@/assets/images/img/mvp-img3.png" alt="">
            <p class="t1" :title="$t('活动分享')">{{ $t('活动分享') }}</p>
            <div class="t2" style="max-width: 350px;">
              <p class="three-text" :title="$t('通过技术或项目实践经验赋能/分享，提升同行技术实战能力')">{{ $t('通过技术或项目实践经验赋能/分享，提升同行技术实战能力') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card4 pl-80 pr-80">
      <div class="t1 mic-semblod ta-c fs-32 lh-36">{{ $t('MVP动态') }}</div>
      <div class="container-1752 mt-46 df fww">
        <template v-if="dynamicList.length > 0">
          <div class="list cup" @click="handleDynamicLink(item)" v-for="item in dynamicList">

            <div class="img-box" :class="item.testd_file?'video-imgbox':''" @click="handleVideo($event, item)">
              <span class="iconfont video-icon icon-you" v-if="item.testd_file"></span>
              <img :src="item.testd_thumb_arr" alt="">
            </div>

            <div class="text-box">
              <div class="td1">
                <div class="d1 df jcsb">
                  <span class="one-text mr-16 fs-18 lh-28 mic-semblod" :title="item.testd_name">
                    {{ item.testd_name }}
                  </span>
                  <div v-if="item.testd_address" class="fn one-text" style="min-width: 82px;max-width: 200px;">
                    <span class="iconfont icon-dingwei"></span>
                    <span class="fn fs-12 ml-4">{{ item.testd_address }}</span>
                  </div>
                </div>
                <div class="d2 df jcsb mt-8">
                  <span class="one-text mr-16 fs-14 lh-22" :title="item.testd_desc">
                    {{ item.testd_desc }}
                  </span>
                  <div class="fn df aic" v-if="item.testd_time">
                    <span class="iconfont icon-Stroke-1"></span>
                    <span class="fs-12 ml-4">{{ item.testd_time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="null-data df fdc jcc aic" style="width: 100%;">
            <img src="@/assets/images/empty_data.png" alt />
            <p class="mt-16">{{ $t('暂无资料') }}</p>
          </div>
        </template>
      </div>


    </div>

    <!-- 视频播放 -->
    <el-dialog title="" :visible.sync="dialogVideoVisible" @close="handleVideoclose" width="800px" class="video-dialog">
      <video ref="videoPlayer" controls style="width: 100%;">
        <source :src="videourl" type="video/mp4">
      </video>
    </el-dialog>

  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mvpDynamicList, mvpList, applyDetail, mvpCommonData } from "@api/expert";
import { setuserfollowAdd } from "@api/home";
export default {
  components: { Swiper, SwiperSlide },

  data() {
    return {
      dialogVideoVisible:false,
      videourl:"",
      numbers: [],
      language: localStorage.getItem('currentLanguage'),
      id: 0,
      user_id: 0,
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: '#topic_next',
          prevEl: '#topic_prev',
        },
      },
      listdata: [],
      yearData: [],
      articles: [],
      dynamicList: [],
      pagination: {
        page: 1,
        total: 0,
        page_size: 10,
      },
      FormData: {
        "curr_year": 0,
      },
      currLanguage: "cn"
    }
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
    this.commonData();
    this.getData();
    this.getMvpDynamicList();
    let Language = localStorage.getItem('currentLanguage'); // 获取本地语言
    this.currLanguage = Language && Language !== 'zh';
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    }
  },
  methods: {

    // guanbi 
    handleVideoclose(){
      // this.videourl='';
      this.$refs.videoPlayer.pause();
      this.$refs.videoPlayer.currentTime = 0;
    },  
    handleDynamicLink(item) {
      if(item.testd_url){
        window.open(item.testd_url, '_blank');
      }
    },
    // 视频播放
    handleVideo(e, item) {
      if (item.testd_file_arr) {
        // 阻止冒泡
        e.stopPropagation();
        this.dialogVideoVisible = true;
        const video = this.$refs.videoPlayer;
        if(video){
          video.load();
        }
        this.videourl=item.testd_file_arr;
      }
    },
    handleArticleLink(item) {
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      let str = "/protal";
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      if (item.compose_type == 10) {
        // const url = str + '/post/info/id/' + item.tp_id; //帖子
        // window.open(url, '_blank');
        this.$navigate('/discuss/info', item.tp_id)
      } else if (item.compose_type == 20) {
        // const url = str + '/topicarticle/info/id/' + item.ttar_id; //文章
        // window.open(url, '_blank');
        this.$navigate('/subject/info', item.ttar_id)
      }
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getData();
    },
    async commonData() {
      const res = await mvpCommonData();
      if (res.status == 200) {
        this.yearData = [
          { value: 0, label: this.$t("全部") },
          ...res.data.year_list,
        ];
      }

    },
    async getData() {
      console.log(this.FormData)
      this.FormData.tesa_type = 20;
      const res = await mvpList({ ...this.FormData, page: this.pagination.page, page_size: this.pagination.page_size });
      if (res.status == 200) {
        this.pagination.total = res.data.total;
        this.listdata = res.data.data;
      }
    },
    async getMvpDynamicList() {
      const res = await mvpDynamicList();
      if (res.status == 200) {
        this.dynamicList = res.data;
      }

    },

    async userfollowAdd(event, item) {
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: item.user_id });
      if (res.status === 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },

    chunkArray(array, chunkSize) {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        result.push(chunk);
      }
      return result;
    },

    // 跳转详情
    handleLink(user_id) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + '/stationed/info/' + user_id + "/10/20"); // 使用编程式导航跳转到 About 页面
    },
    handleStationed(path) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep(){
  .video-dialog{
    .el-dialog__body{
    padding: 0 20px 30px;
  }
  .el-dialog__title{
    opacity: 0;
  }
  .el-dialog {
    border-radius: 12px;
}
  }
 
}
.card4 {
  padding-bottom: 120px;

  .list {
    width: calc(33.33% - 13.33px);
    margin-right: 20px;
    border-radius: 6px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 1);
    transition: all .36s;
    margin-bottom: 16px;

    &:hover {
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);

      .d1 .mic-semblod {
        color: #B7251E;
      }

      .img-box img {
        transform: scale(1.02);
      }
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    .img-box {
      height: 240px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;

      &.video-imgbox::after{
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
      }

      .video-icon {
        display: block;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        text-align: center;
        line-height: 46px;
        font-size: 24px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: rgba(255, 255, 255, 0.5);
        color: #ffffff;
        z-index: 10;
        padding-left: 2px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all .6s;
      }
    }

    .text-box {
      padding: 16px;
    }
  }
}

.pageing-box {

  ::v-deep() {

    .el-pagination .btn-prev .el-icon,
    .el-pagination .btn-next .el-icon {
      font-size: 16px;

    }

    .el-pagination .btn-next {
      padding-left: 0;
      padding-right: 0;
    }

    .el-pagination .btn-prev {
      padding-right: 0;
      padding-left: 0;
    }

    .el-pagination>button {
      width: 44px;
      height: 44px;
      background: #eaeaea;
      border-radius: 50%;
      margin: 0 10px;
      text-align: center;
      line-height: 44px;
      font-size: 13px;
      color: #9D9D9D;
      cursor: pointer;

      &:disabled {
        opacity: 0.6 !important;
        cursor: auto;
      }

      &:hover {
        opacity: 0.8;
      }
    }

  }


}

.mvp-contentlist {
  .list {
    width: calc(20% - 32px);
    margin-right: 40px;
    margin-bottom: 40px;
    position: relative;
    border-radius: 12px;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
    border: 1px solid transparent;
    transition: all .36s;

    .follow-btn {
      position: absolute;
      left: -1px;
      bottom: -60px;
      width: calc(100% + 2px);
      height: 60px;
      background: rgb(183, 37, 30);
      color: #ffffff;
      border-radius: 0 0 12px 12px;
      z-index: 100;
      font-size: 16px;
      z-index: 666;
      display: none;
      transition: all .36s;

    }

    .follow-btn.follow-btnend {
      opacity: 0.6;
    }

    // &::after{
    //   content: "";
    //   display: block;
    //   width: calc(100% - 2px);
    //   height: 100%;
    //   border-radius: 12px;
    //   border: 1px solid transparent;
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   transition: all .26s;
    //   z-index: -1;
    // }
    &:hover {
      border: 1px solid rgba(183, 37, 30, 1);
      border-radius: 12px 12px 0 0;

      .follow-btn {
        display: block;
      }

      // &::after {
      //   border: 1px solid rgba(183, 37, 30, 1);
      //   border-radius: 12px 12px 0 0;
      // }

      .top-img {
        img {
          transform: scale(1.1);
        }
      }
    }



    .art-box {
      padding-top: 6px;
      margin-left: -10px;

      .li {
        color: #191919;
        font-size: 16px;
        line-height: 24px;
        margin-top: 4px;

        span {
          color: #B7251E;
        }
      }
    }

    .c-21 {
      color: #212121;
    }

    .name {
      color: #121212;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);


      .dj {
        min-width: 60px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        border-radius: 20px;
        font-size: 12px;
        overflow: hidden;

        img {
          max-height: 100%;
        }

        // &.d1 {
        //   color: rgba(100, 100, 100, 1);
        //   background: linear-gradient(-54.83deg, rgba(221.1149139404297, 219.5028533935547, 239.0625, 0.5) 1%, rgba(213.10714721679688, 216.9227294921875, 225.40179443359375, 0.5) 100%);
        // }

        // &.d3 {
        //   color: rgba(213, 135, 7, 1);
        //   background: linear-gradient(119.60deg, rgba(255, 237.0940399169922, 180.81817626953125, 0.36), rgba(253.8616180419922, 230.9424591064453, 198.47361755371094, 0.36) 100%);
        // }

        // &.d2 {
        //   color: rgba(69, 63, 255, 1);
        //   background: linear-gradient(90.00deg, rgba(232.66519165039062, 230.65908813476562, 255, 0.5) 1%, rgba(223.24400329589844, 231.33285522460938, 249.30804443359375, 0.5) 100%);
        // }

      }
    }

    .top-img {
      width: 100%;
      padding-bottom: 99.33%;
      overflow: hidden;
      position: relative;
      border-radius: 12px 12px 0 0;

      img {
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        position: absolute;
        transition: all 2s;
      }
    }

    .text-box {
      height: 224px;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

.mvp-search {
  .t1 {
    text-align: center;
    min-width: 106px;
    margin-right: 31px;
  }

  .list {
    color: #191919;
    cursor: pointer;
    line-height: 36px;

    &.active {
      color: #B7251E;
    }
  }
}

.leng10box {
  .leng10list {

    width: calc(20% - 41px) !important;
    margin-right: 40px;
  }

  .leng10list:nth-child(5n) {
    margin-right: 0;


  }
}

.swiper-container {
  width: calc(100% + 40px);
  padding-bottom: 18px;
  padding-left: 20px;
  padding-right: 12px;
  // width: calc(100% + 36px);
  // padding-left: 18px;
  // padding-right: 18px;
  // position: relative;
  // left: -18px;
}

.list-box {
  position: relative;
  box-sizing: border-box;
  // border: 1px solid transparent;
  transition: border .36s;



  &:hover {
    &.list-boxend {
      .list {
        border: 1px solid rgba(183, 37, 30, 0.6);
      }
    }

    // .follow-btn {
    //   display: block;
    //   bottom: -56px;
    // }

    .list {
      border: 1px solid rgb(183, 37, 30);
      border-radius: 12px 12px 0 0;
    }
  }




}

.card3 {
  background-image: url("../../assets/images/img/mvp-cardbt.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  padding-bottom: 206px;

  .li {
    text-align: center;
    width: 360px;
    word-break: break-word;
  }

  .t1s {
    text-align: center;
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;

  }

  .t1 {
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 28px;
    font-weight: 400;
    line-height: 28px;
    margin-top: 40px;
  }

  .t2 {
    color: rgb(18, 18, 18);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 20px;
  }
}

.card2-box {
  padding-bottom: 80px;

  p {
    word-break: break-word;
  }

  .li {
    word-break: break-word;

    img {
      width: 200px;
    }

    p.ta-c {
      color: rgb(18, 18, 18);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 20px;
      font-weight: 400;
      line-height: 28px;
      margin-top: 6px;
    }

    .desc {
      max-width: 296px;
      margin: 0 auto;
      color: rgb(76, 76, 76);
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 1px;
      margin-top: 12px;
      word-break: break-word;
    }
  }
}

.cars2 {
  padding-top: 132px;

  .t1 {
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 44px;
    font-weight: 400;
    line-height: 60px;
    text-align: center;
  }

  .t2 {
    text-align: center;
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;
    margin-top: 68px;
  }
}

.card1 {
  height: 435px;
  background-image: url("../../assets/images/mvp-bg.jpeg");
  background-size: 100% 100%;
  background-position: left center;
  margin-top: 24px;
  padding: 60px;

  .t1 {
    color: rgb(98, 98, 98);
    font-family: "PingFang-SC";
    font-size: 20px;
    font-weight: 400;
    line-height: 45px;
  }

  .t2 {
    font-family: "PingFang-SC";
    font-size: 56px;
    font-weight: 400;
    line-height: 102px;
    letter-spacing: 2px;
    margin-top: 1px;

    .s1 {
      color: #191919;
    }

    .s2 {
      color: #B7251E;
    }
  }

  .desc {
    max-width: 1320px;
    color: rgb(84, 84, 84);
    font-family: "PingFang-SC";
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 2px;
    margin-top: 9px;
  }
}

.box {

  .page-tab {
    span {
      width: 208px;
      height: 52px;
      line-height: 52px;
      border: 1px solid rgb(217, 217, 217);
      border-radius: 4px;
      padding-left: 20px;
    }

    .ip1 {
      padding-left: 54px;

      border: 1px solid rgb(217, 217, 217);
      border-radius: 50px 4px 4px 4px;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: calc(100% + 0px);
        height: calc(100% + 0px);
        border-radius: 50px 4px 4px 4px;
        border: 1px solid #B7251E;
        position: absolute;
        left: 0px;
        top: 0px;
        opacity: 0;
        transition: all .26s;

      }

      &::before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 16px;
        border-radius: 1px;
        background: rgb(183, 37, 30);
        margin-right: 8px;
        position: relative;
        top: 1px;
      }

    }

    .ip1:hover {
      &::after {
        content: "";
        opacity: 1;
        width: calc(100% + 6px);
        height: calc(100% + 6px);
        left: -4px;
        top: -4px;
      }
    }

    span.active {
      width: 208px;
      height: 58px;
      border: none;
      background-image: url("../../assets/images/tab1-bg.png");
      background-size: 100% 100%;
      padding-left: 44px;
      color: #FFFFFF;
      line-height: 56px;
    }
  }
}

.topcontent-page {
  background-image: url("../../assets/images/gezi.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 40px;

  .t1 {
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    letter-spacing: 4px;
    line-height: 44px;
  }

  .t2 {
    font-family: "MicrosoftYaHeiSemibold";
    text-align: center;
    color: rgb(18, 18, 18);
    font-size: 50px;
    font-weight: 400;
    line-height: 60px;
    letter-spacing: 6px;
    margin-top: 4px;
  }

  .desc1 {
    color: rgb(76, 76, 76);
    font-size: 20px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 1px;
    margin-top: 30px;
    // padding: 0 206px;
  }
}

.swiper-btn {
  height: 44px;
  position: relative;
  top: -18px;
  z-index: 0;

  .swiper-button-prev,
  .swiper-button-next {


    &:hover {
      opacity: 0.8;
    }

    &::after {
      font-size: 13px;
      color: #9D9D9D;
    }

    width: 44px;
    height: 44px;
    background: rgb(234, 234, 234);
    border-radius: 50%;
    position: relative;
    right: auto;
    left: auto;
    top: auto;
    margin-top: 0;
    margin: 0 10px;
  }
}

.person-list {
  padding-top: 50px;
  overflow: hidden;
  max-width: 1792px;
  margin: 0 auto;
  // width: calc(100% + 48px);

  .list {
    width: 100%;
    // height: 460px;
    border: 1px solid transparent;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
    margin-right: 40px;
    margin-bottom: 40px;
    cursor: pointer;

    &:hover {
      .img-box img {
        transform: scale(1.1)
      }

      .name {
        color: #B7251E;
      }
    }

    &:nth-child(5n) {
      margin-right: 0;
    }

    .img-box {
      width: 100%;
      // height: 314px;
      padding-bottom: 99.33%;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        transition: all 2s;
      }
    }

    .text-box {
      padding: 16px 24px 0;
      height: 171px;
    }

    .name {
      color: rgb(18, 18, 18);
      font-size: 22px;
      font-weight: 400;
      line-height: 28px;
    }

    .company {
      color: rgb(18, 18, 18);
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      height: 44px;
      margin-top: 8px;
    }

    .desc {
      color: rgb(119, 119, 119);
      font-size: 14px;
      font-weight: 400;
      margin-top: 8px;
      line-height: 22px;
    }
  }
}
</style>
.country-box{
  span{
    background: #F3F3F3;
    padding: 3px 8px;
    border-radius: 4px;
    color: #333;
    font-size: 12px;
  }
}